{
  "nav": {
    "tools": "Инструменты",
    "openMenu": "Открыть меню",
    "subscription": "Подписка",
    "configuration": "Настройки",
    "account": "Аккаунт",
    "administration": "Администрирование",
    "ourTools": "Наши инструменты",
    "pricing": "Цены",
    "faq": "FAQ"
  },
  "toolItems": {
    "flippingTool": "Инструмент флиппинга",
    "dropshipTool": "Инструмент дропшипа",
    "housingTool": "Инструмент жилья",
    "inventoryAnalysisTool": "Инструмент анализа инвентаря",
    "snipeAlerts": "Снайп-оповещения",
    "realmStats": "Статистика реалма",
    "tsmListGenerator": "Генератор списков TSM",
    "tsmProfileSetupGuide": "Руководство по настройке профиля TSM",
    "dashboard": "Панель управления",
    "classicDeals": "Classic Deals"
  },
  "configItems": {
    "regionRealm": "Настройка региона и реалма",
    "personal": "Личные настройки",
    "discord": "Настройка Discord"
  },
  "accountItems": {
    "settings": "Настройки"
  },
  "adminItems": {
    "stats": "Статистика",
    "userInfo": "Информация о пользователе",
    "goldSubscription": "Золотая подписка",
    "itemLookup": "Поиск предмета",
    "snipeAudit": "Аудит снайпа",
    "emailPreviews": "Предпросмотр писем"
  },
  "buttons": {
    "login": "Войти",
    "logout": "Выйти",
    "register": "Зарегистрироваться",
    "registerNow": "Зарегистрироваться сейчас",
    "signIn": "Войти",
    "tryAgain": "Попробовать снова",
    "goBack": "Назад",
    "cancel": "Отмена",
    "deactivate": "Деактивировать",
    "upgrade": "Улучшить",
    "upgradeToPremium": "Перейти на Premium",
    "upgradeNow": "Улучшить сейчас",
    "unlockPremiumFeatures": "Разблокировать функции Premium",
    "getMoreResultsAndFilters": "Получить больше результатов и фильтров",
    "goToConfig": "Перейти к настройкам",
    "save": "Save",
    "close": "Закрыть",
    "actions": "Действия",
    "copyToClipboard": "Скопировать в буфер обмена",
    "saving": "Сохранение…"
  },
  "loading": {
    "pleaseWait": "Подождите",
    "important": "Важно",
    "defaultWarning": "Пожалуйста, не перезагружайте страницу в процессе.",
    "progressComplete": "{{percent}}% завершено",
    "loadingAriaLabel": "Загрузка",
    "loadingProgressAriaLabel": "Прогресс загрузки: {{percent}}%"
  },
  "error": {
    "somethingWentWrong": "Что-то пошло не так",
    "defaultMessage": "Произошла ошибка! Подождите несколько секунд и перезагрузите страницу",
    "fetchDataFailed": "Не удалось загрузить данные аукциона"
  },
  "cancelDialog": {
    "title": "Отменить подписку",
    "confirmQuestion": "Вы уверены, что хотите отменить подписку?",
    "loseAccessNotice": "Вы потеряете доступ к инструментам и с вас больше не будут взиматься платежи.",
    "warning": "Внимание: после отмены подписки вы потеряете доступ к инструментам по истечении оплаченного периода. Возврат средств за отменённые подписки не производится."
  },
  "dialog": {
    "confirm": "Подтвердить",
    "cancel": "Отмена"
  },
  "realmLimitPopup": {
    "title": "Превышен лимит реалмов",
    "description": "Вы выбрали больше реалмов для продажи, чем позволяет базовая подписка. Измените настройки или перейдите на premium."
  },
  "tooltipOverlay": {
    "upgradeTitle": "Перейти на Premium",
    "upgradeSubtitle": "Раскройте весь потенциал Flipping Pal",
    "enhancedFeatures": "Расширенные функции",
    "exclusiveFeatures": "Эксклюзивные функции Premium",
    "alsoIncluded": "Также включено"
  },
  "footer": {
    "changelog": "Список изменений"
  },
  "logoAlt": "Flipping Pal - ваш любимый сайт для WoW флиппинга",
  "toggleNavAriaLabel": "Переключить меню навигации",
  "mainNavAriaLabel": "Основная навигация",
  "toolNavAriaLabel": "Навигация по инструментам",
  "simpleNavAriaLabel": "Простая навигация",
  "footerNavAriaLabel": "Навигация в подвале",
  "clipboard": {
    "copied": "Скопировано в буфер обмена!",
    "tsmCopied": "Строка TSM скопирована в буфер обмена!",
    "exportCopied": "Код экспорта успешно скопирован в буфер обмена.",
    "auctionatorCopied": "Списки покупок Auctionator скопированы в буфер обмена!",
    "titleCopied": "{{title}} скопировано в буфер обмена!",
    "copyFailed": "Не удалось скопировать в буфер обмена"
  },
  "favorites": {
    "added": "Добавлено в избранное",
    "removed": "Удалено из избранного"
  },
  "enabled": "включено",
  "disabled": "выключено",
  "dataRefreshed": "Данные обновлены! Найдено {{count}} возможностей.",
  "notFound": {
    "title": "Страница не найдена"
  },
  "paymentSuccess": {
    "title": "Платёж выполнен"
  },
  "pagination": {
    "summary": "Всего найдено товаров: {{total}} | Результатов на странице: {{perPage}}",
    "summaryWithPages": "Всего найдено товаров: {{total}} | Результатов на странице: {{perPage}} | Всего страниц: {{pages}}",
    "label": "Навигация по страницам",
    "firstPage": "Первая страница",
    "previousPage": "Предыдущая страница",
    "nextPage": "Следующая страница",
    "lastPage": "Последняя страница",
    "pageAriaLabel": "Страница {{page}}"
  },
  "stats": {
    "totalInvestment": "Общая инвестиция",
    "estimatedSellPrice": "Ожидаемая цена продажи",
    "profitAfterAHCut": "Прибыль после комиссии аукционного дома"
  },
  "filters": {
    "searchItems": "Поиск предметов...",
    "watchVideoGuide": "Смотреть видеогайд",
    "watchVideoIntro": "Смотреть вводное видео",
    "crossRealmVideoGuide": "Видеогайд по инструменту межреалмового флиппинга",
    "dropshipVideoGuide": "Видеогайд по инструменту дропшип-флиппинга",
    "housingVideoGuide": "Видеогайд по инструменту жилья",
    "downloadXLSX": "Скачать данные в формате XLSX",
    "getAuctionatorLists": "Получить списки Auctionator",
    "quality": "Качество",
    "selectQuality": "Выбрать качество",
    "qualities": "качеств",
    "expansions": "Дополнения",
    "selectExpansions": "Выбрать дополнения",
    "expansionsMultiple": "дополнений",
    "sellingRealms": "Реалмы продажи",
    "selectSellingRealms": "Выбрать реалмы продажи",
    "sellingRealmsMultiple": "реалмов продажи",
    "buyingRealms": "Реалмы покупки",
    "selectBuyingRealms": "Выбрать реалмы покупки",
    "buyingRealmsMultiple": "реалмов покупки",
    "categories": "Категории",
    "selectCategories": "Выбрать категории",
    "categoriesMultiple": "категорий",
    "sellRate": "Темп продаж",
    "saleAvg": "Средняя цена продажи",
    "haveCraftedItems": "Созданные предметы",
    "profitOnSaleAvg": "Прибыль от средней цены продажи",
    "saleAvgVsBuyPercent": "Средняя продажа vs покупка %",
    "profitSellVsBuy": "Прибыль (продажа vs покупка)",
    "profitPercent": "Прибыль %",
    "maxGoldBuyout": "Макс. мгновенная покупка (золото)",
    "ilvl": "ilvl",
    "activateProfitOnSaleAvg": "Активировать прибыль от средней цены продажи",
    "regionMarketValue": "Региональная рыночная стоимость",
    "regionHistorical": "Региональная историческая стоимость",
    "modeRecalculate": "Пересчитать",
    "modeFilter": "Фильтровать",
    "modeRecalculateHint": "Изменения фильтров пересчитывают результаты на сервере",
    "modeFilterHint": "Изменения фильтров только сужают уже загруженные результаты",
    "modeAria": "Поведение при изменении фильтров",
    "modeLabel": "При изменении фильтров"
  },
  "table": {
    "noData": "Данные не найдены",
    "sellVsBuyTooltip": "Комиссия аукционного дома 5% учитывается при расчёте прибыли",
    "toggleAllFavorites": "Переключить все избранные",
    "clickToCopy": "Нажмите для копирования: {{name}}",
    "priceAfterAHCut": "Цена после комиссии АД: {{price}}",
    "noCompetition": "Нет конкурентов",
    "noCompetitionTooltip": "Нет известных лотов на реалме продажи.",
    "population": "Население: {{population}}",
    "viewOnWowhead": "Посмотреть {{name}} на Wowhead",
    "addToFavorites": "Добавить в избранное",
    "removeFromFavorites": "Удалить из избранного",
    "sessionExpiredFavorite": "Сессия истекла. Пожалуйста, войдите снова.",
    "failedToUpdateFavorite": "Не удалось обновить избранное",
    "addSnipeAlert": "Добавить snipe-алерт",
    "editSnipeAlert": "Редактировать snipe-алерт",
    "headers": {
      "itemName": "Название предмета",
      "category": "Категория",
      "ilvl": "Ур. предмета",
      "sellRate": "Частота продаж",
      "expansion": "Дополнение",
      "quality": "Качество",
      "extraStats": "Доп. статы",
      "saleAvg": "Сред. продажа",
      "regionMarketValue": "РЦ региона",
      "saleAvgVsBuy": "Сред. продажа vs Покупка",
      "sellVsBuy": "Продажа vs Покупка",
      "sellPrice": "Цена продажи",
      "sellRealm": "Реалм продажи",
      "buyPrice": "Цена покупки",
      "buyRealm": "Реалм покупки"
    },
    "columnsTitle": "Колонки",
    "columnsReset": "Сбросить",
    "columnsDragToReorder": "Перетащите для изменения порядка",
    "columnsToggleVisibility": "Нажмите на глаз для переключения видимости",
    "columnSettings": "Настройки колонок",
    "dragReorder": "Перетащите {{column}} для изменения порядка",
    "hideColumn": "Скрыть {{column}}",
    "showColumn": "Показать {{column}}",
    "rowActions": "Действия со строкой",
    "actions": {
      "selectionSection": "Выбор",
      "pinSection": "Закрепить вверху",
      "selectPage": "Выбрать страницу",
      "deselectPage": "Снять выбор со страницы",
      "selectAll": "Выбрать все",
      "deselectAll": "Снять весь выбор",
      "sortFavorites": "Закрепить избранное",
      "sortSnipes": "Закрепить оповещения снайпа",
      "sortSelected": "Закрепить выбранные",
      "columnSettings": "Настройки колонок..."
    },
    "sortHint": "Нажмите для сортировки",
    "sortHintMulti": "Нажмите для сортировки · Shift+клик для вторичной сортировки",
    "selectRow": "Выбрать {{name}}",
    "emptyFiltered": "Ни один предмет не соответствует текущим фильтрам",
    "emptyResetFilters": "Сбросить фильтры",
    "emptyUpdating": "Идёт обновление данных региона — новые данные появятся в ближайшее время."
  },
  "multipleSelect": {
    "noResults": "Результатов не найдено",
    "selectAll": "Выбрать все",
    "clearAll": "Очистить все",
    "selectOption": "Выбрать опцию",
    "selectMultipleOptions": "Выбрать несколько опций",
    "selected": "выбрано",
    "searchOptions": "Поиск опций",
    "noItemsSelected": "Элементы не выбраны",
    "search": "Поиск...",
    "items": "элементов"
  },
  "hierarchicalSelect": {
    "selectAll": "Выбрать все",
    "clearAll": "Очистить все",
    "expand": "Развернуть",
    "collapse": "Свернуть",
    "selected": "выбрано",
    "noItemsSelected": "Выберите категории...",
    "items": "категории",
    "triggerAriaLabel": "Выбрать {{items}}. Выбрано: {{count}}."
  },
  "hoverChart": {
    "high": "Выс.:",
    "low": "Низ.:",
    "avg": "Сред.:"
  },
  "tokenDisplay": {
    "label": "Жетон WoW",
    "signalBuy": "Сигнал к покупке — цена сейчас выгодная",
    "signalWait": "Подождите — цена, вероятно, продолжит снижаться",
    "signalHold": "Держите — сейчас нет чёткого тренда",
    "loading": "Загрузка...",
    "error": "Ошибка",
    "priceHistory": "История цен за 14 дней",
    "high": "Выс.: ",
    "low": "Низ.: ",
    "avg": "Сред.: ",
    "momentum": "Динамика",
    "slowing": "Замедление ({{steps}})",
    "atCap": "На пределе 1%",
    "steps": "{{count}} шаг",
    "stepsPlural": "{{count}} шага/шагов"
  },
  "nextUpdate": {
    "nextDataUpdate": "Следующее обновление данных",
    "dataSourceStatus": "Статус источников данных",
    "tsmData": "Данные TSM:",
    "blizzardRealm": "Реалм Blizzard:",
    "liveUpdates": "Обновления в реальном времени:",
    "connected": "Подключено",
    "reconnecting": "Подключение...",
    "retry": "Повторить",
    "autoRefresh": "Автообновление:",
    "autoRefreshEnabled": "Страница автоматически обновится при появлении новых данных",
    "autoRefreshDisabled": "Нажмите на значок обновления, когда новые данные будут готовы",
    "loadingStatus": "Загрузка статуса данных...",
    "viewStatus": "Посмотреть статус источников данных",
    "refreshData": "Обновить данные",
    "reloading": "Перезагрузка",
    "liveUpdatesConnected": "Обновления в реальном времени подключены",
    "liveUpdatesReconnecting": "Подключение...",
    "tsmFresh": "Данные TSM актуальны (< 24ч)",
    "tsmStale24": "Данные TSM устаревают (24-25ч)",
    "tsmStale25": "Данные TSM устарели (> 25ч)",
    "toggleAutoRefresh": "Переключить автообновление"
  },
  "regionUpdateProgress": {
    "updating": "Обновление данных региона",
    "realmsProgress": "{{updated}}/{{total}} реалмов ({{percent}}%)",
    "autoRefresh": "Данные обновятся автоматически, когда будут готовы",
    "reloadPartial": "Частичные данные доступны — загрузить сейчас"
  },
  "filterFlyout": {
    "filtersButton": "Фильтры",
    "loadingPresets": "Загрузка...",
    "selectPreset": "Выбрать пресет...",
    "presetsSection": "Пресеты",
    "save": "Сохранить",
    "update": "Обновить",
    "delete": "Удалить",
    "export": "Экспорт",
    "import": "Импорт",
    "importPreset": "Импортировать пресет…",
    "presetNamePlaceholder": "Название пресета...",
    "shareCode": "Поделиться кодом:",
    "copy": "Копировать",
    "done": "Готово",
    "pasteCodePlaceholder": "Вставьте код сюда...",
    "applyFilters": "Применить фильтры",
    "resetFilters": "Сбросить фильтры",
    "refreshNow": "Обновить сейчас",
    "reset": "Сбросить",
    "deletePresetTitle": "Удалить пресет",
    "deletePresetMessage": "Вы уверены, что хотите удалить этот пресет? Это действие нельзя отменить."
  },
  "discord": {
    "title": "Интеграция с Discord",
    "description": "Привяжите аккаунт Discord, чтобы получать персонализированные уведомления и обновления от нашего бота.",
    "accountLinked": "Аккаунт Discord привязан",
    "connectedAs": "Подключено как:",
    "unlink": "Отвязать",
    "dmVerifiedBadge": "Личные сообщения подтверждены: Ваш Discord может получать уведомления от нашего бота.",
    "dmVerificationTitle": "Требуется подтверждение личных сообщений",
    "dmVerificationDesc": "Чтобы включить уведомления, нам нужно убедиться, что наш бот может отправлять вам личные сообщения. Убедитесь, что личные сообщения включены хотя бы на одном сервере, где есть наш бот.",
    "sendVerificationCode": "Отправить код подтверждения в мой Discord",
    "sendingCode": "Отправка кода...",
    "codeSentInstructions": "Проверьте личные сообщения в Discord — там должен быть 6-значный код от нашего бота. Если вы не получили сообщение, проверьте настройки в разделе Контент и социальные функции > Социальные разрешения, что личные сообщения включены.",
    "enterCodePlaceholder": "Введите 6-значный код",
    "verify": "Подтвердить",
    "resendCode": "Отправить код повторно",
    "notificationSettings": "Настройки уведомлений",
    "verifyDmsFirst": "(сначала подтвердите личные сообщения)",
    "botFeaturesAvailable": "Функции бота доступны: Теперь вы можете получать личные сообщения об обновлениях регионов, снайпах предметов и питомцев, снайпах iLvl BoE и цене токена WoW.",
    "notConnected": "Не подключено: Привяжите аккаунт Discord, чтобы включить уведомления и функции бота.",
    "connectingToDiscord": "Подключение к Discord...",
    "linkAccount": "Привязать аккаунт Discord",
    "regionUpdateLabel": "Уведомления об обновлениях региона",
    "regionUpdateDesc": "Получайте уведомления, когда данные аукционов обновляются для ваших выбранных регионов.",
    "sendTestDm": "Отправить тестовое ЛС",
    "sendingTest": "Отправка…",
    "sendTestWebhook": "Тест",
    "testMessageHint": "Отправьте тестовое сообщение, чтобы проверить доставку в Discord без ожидания реального снайпа.",
    "categoriesTitle": "Категории уведомлений",
    "categoriesDesc": "Направляйте оповещения о снайпах в разные каналы Discord. У каждой категории свой URL вебхука и режим упоминаний.",
    "categoriesPremiumHint": "Для дополнительных категорий требуется премиум-подписка.",
    "categoryNamePlaceholder": "Название категории",
    "webhookUrlPlaceholder": "https://discord.com/api/webhooks/...",
    "mentionLabel": "Упоминание:",
    "defaultLabel": "По умолчанию",
    "defaultCategoryTitle": "Категория по умолчанию",
    "noWebhookSet": "вебхук не задан",
    "setAsDefault": "Сделать категорией по умолчанию",
    "edit": "Изменить",
    "delete": "Удалить",
    "add": "Добавить",
    "addCategory": "+ Добавить категорию",
    "deleteCategoryTitle": "Удалить категорию",
    "deleteCategoryMessage": "Удалить категорию «{{name}}»? Назначенные ей оповещения будут использовать категорию по умолчанию."
  },
  "csvExport": {
    "title": "Экспорт CSV",
    "noItems": "Нет доступных элементов.",
    "copy": "Копировать в буфер обмена",
    "copied": "CSV скопирован в буфер обмена!",
    "copyFailed": "Не удалось скопировать",
    "download": "Скачать CSV"
  },
  "updateBanner": {
    "title": "Доступно обновление",
    "description": "Новая версия готова.",
    "reload": "Перезагрузить",
    "dismiss": "Закрыть"
  },
  "premiumPreviewBanner": {
    "title": "У вас полный доступ к Premium",
    "dayLeftOne": "Остался 1 день",
    "daysLeft": "Осталось дней: {{count}}",
    "dismiss": "Закрыть"
  },
  "tour": {
    "start": "Запустить тур по этой странице"
  },
  "filterSidebar": {
    "profitRange": "Диапазон прибыли",
    "crafted_include": "Все предметы",
    "crafted_excluded": "Исключить крафт",
    "crafted_exclusive": "Только крафт",
    "showPositiveSaleAvgVsBuy": "Только положительное среднее продаж vs покупка",
    "presetClickToDeselect": "Нажмите для отмены выбора пресета",
    "collapseSidebar": "Свернуть фильтры",
    "expandSidebar": "Развернуть фильтры"
  },
  "dashboard": {
    "loadError": "Не удалось загрузить данные панели. Проверьте подключение и повторите попытку.",
    "greeting": {
      "morning": "Доброе утро",
      "afternoon": "Добрый день",
      "evening": "Добрый вечер"
    },
    "subtitle": "Вот что происходит на аукционе сегодня.",
    "kpi": {
      "opportunities": "Возможности"
    },
    "topOpportunities": {
      "title": "Лучшие возможности",
      "viewAll": "Посмотреть все",
      "itemsFound": "предметов найдено на",
      "realms": "серверах",
      "openTool": "Открыть инструмент флиппинга",
      "ilvl": "ilvl",
      "sellRate": "скорость продаж",
      "tabFastSelling": "Fast Selling",
      "tabTopBuys": "Top Buys",
      "sellRateMin": "Sell Rate ≥",
      "buyBelowPct": "Buy Below",
      "noItems": "No items match the current filters",
      "saveFailed": "Не удалось сохранить настройки. Восстановлено последнее сохранённое значение.",
      "saved": "Сохранено",
      "sellRateTooltip": "Скорость продаж измеряется по шкале от 0 до 1: доля выставленных лотов, которые действительно продаются за день. 0,1 ≈ 10% лотов."
    },
    "recentSnipes": {
      "title": "Последние снайпы",
      "monitoringRealms": "Мониторинг {{count}} серверов",
      "vsTarget": "vs цель",
      "itemsMonitored": "предметов отслеживается",
      "configureAlerts": "Настроить уведомления",
      "noSnipes": "Нет снайпов в этом цикле",
      "saved": "сэкономлено"
    },
    "topRealms": {
      "title": "Top Realms",
      "sortPopVsAuctions": "Population vs Auctions",
      "sortPriceRatio": "Price Ratio",
      "sortNumAuctions": "Number of Auctions",
      "viewRealmStats": "Открыть статистику реалмов"
    },
    "quickAccess": {
      "title": "Быстрый доступ"
    },
    "onboarding": {
      "title": "Начало работы",
      "progress": "Выполнено: {{done}}/{{total}}",
      "hide": "Скрыть чек-лист",
      "steps": {
        "realms": "Настройте свои серверы",
        "preset": "Создайте стартовый пресет фильтров",
        "flipping": "Запустите первое сканирование флиппинга",
        "discordLink": "Привяжите аккаунт Discord",
        "snipe": "Настройте снайп-оповещения",
        "discordJoin": "Присоединитесь к серверу Discord"
      },
      "createPreset": "Создать пресет",
      "creatingPreset": "Создание…",
      "starterPresetName": "Стартовый",
      "configureRealmsFirst": "Сначала настройте серверы, чтобы создать пресет",
      "presetLimitReached": "Вы достигли лимита сохранённых пресетов",
      "createPresetFailed": "Не удалось создать пресет. Повторите попытку."
    },
    "activity": {
      "title": "Активность",
      "timeAgoLess1m": "<1м назад",
      "timeAgoMinutes": "{{count}}м назад",
      "timeAgoHours": "{{count}}ч назад",
      "dataRefreshed": "Данные обновлены — найдено {{n}} возможностей",
      "realmDataUpdated": "Данные серверов {{region}} обновлены",
      "waitingForData": "Ожидание первого обновления данных…",
      "snipeAlertsActive": "Снайп-оповещения активны и отслеживают ваши серверы",
      "tokenTracked": "Цена WoW-токена отслеживается каждые 20 минут"
    }
  },
  "versionSwitcher": {
    "label": "Game version",
    "retail": "Retail",
    "classicEra": "Classic Era",
    "switchFailed": "Failed to switch game version"
  },
  "classicDeals": {
    "title": "Classic Deals",
    "subtitle": "Buy items listed far below the next-cheapest copy on the same realm, then relist for a profit.",
    "region": "Region",
    "realms": "Realms",
    "selectRealms": "Select realms",
    "realmsSelected": "realms selected",
    "saveRealms": "Save realms",
    "findDeals": "Find deals",
    "loading": "Loading…",
    "selectRealmFirst": "Select at least one realm first",
    "saveFailed": "Failed to save realms",
    "realmsSaved": "Realms saved",
    "fetchFailed": "Failed to load deals",
    "noDeals": "No deals found for the selected realms.",
    "emptyPrompt": "Select your realms and click Find deals.",
    "colItem": "Item",
    "colRealm": "Realm",
    "colLowest": "Lowest",
    "colNext": "Next",
    "colProfit": "Profit",
    "colGap": "Gap",
    "colQty": "Qty",
    "colSaleRate": "Sale rate"
  },
  "backToTop": "Наверх",
  "slider": {
    "min": "Мин",
    "max": "Макс",
    "minAriaLabel": "Минимальное значение",
    "maxAriaLabel": "Максимальное значение",
    "numericInput": "Числовое поле {{label}}"
  },
  "inputBox": {
    "clear": "Очистить поле",
    "required": "обязательно"
  },
  "auctionator": {
    "title": "Списки покупок Auctionator",
    "account": "Аккаунт:",
    "allAccounts": "Все аккаунты",
    "noItems": "Нет предметов для выбранного аккаунта."
  },
  "popup": {
    "getTitle": "Получить {{title}}",
    "content": "Содержимое",
    "noContent": "Содержимое недоступно",
    "copyTitle": "Скопировать {{title}}",
    "copyContent": "Скопировать содержимое",
    "titleContent": "Содержимое {{title}}",
    "videoContent": "Видео",
    "videoNotSupported": "Ваш браузер не поддерживает тег видео."
  },
  "snipePopup": {
    "ariaLabel": "Снайп-оповещение для {{name}}",
    "titleItem": "Снайп-оповещение о предмете",
    "titlePet": "Снайп-оповещение о питомце",
    "maxBuyoutPrice": "Максимальная цена выкупа",
    "pricePlaceholder": "напр. 500g или 500g 50s",
    "saving": "Сохранение...",
    "updateAlert": "Обновить оповещение",
    "setAlert": "Установить оповещение"
  },
  "refreshingData": "Обновление данных...",
  "toolAccess": {
    "subscriptionRequired": "Для использования этого инструмента нужна активная подписка!",
    "premiumRequired": "Для использования этого инструмента нужна активная премиум-подписка!"
  }
}
